// extracted by mini-css-extract-plugin
module.exports = {"strip":"styles_strip__prATq"};